import { FC } from "react";
import { Check, Download } from "@mui/icons-material";
import { Button } from "@mui/material";
import { ERequestSubtype, ERequestStatus, ERequestStatusColor, ERequestType, INotificationRequest } from "../../../../common-interfaces/interfaces";
import { useRecoilState } from "recoil";
import { displayRequestsAtom } from "../../utils/requestAtoms";
import { useApiWrapper } from "../../../../hooks/useApiWrapper";
import useOnCopy from "../../../../hooks/useOnCopy";
import { PrintError } from "../../../../helpers/utils";
import { enqueueSnackbar } from "notistack";
import useRenameModal from "../../../../hooks/useRenameModal";

const AcceptButton: FC<{
  handleAction: (value: ERequestStatus) => void;
  requestID: string;
  downloadIcon: boolean;
}> = ({ handleAction, requestID, downloadIcon }) => {
  const [displayRequests] = useRecoilState(displayRequestsAtom);
  const { getWithAuth, postWithAuth } = useApiWrapper();
  const { handleAddCustom, handleCopy, verifyCustomName } = useOnCopy();
  const { openRenameModal, RenameModal } = useRenameModal();

  const handleShareAccept = async (req: INotificationRequest) => {
    try {
      const res = await getOriginal(req);
      await handleSaveCustom(res, req.subtype);
    } catch (e) { }
  };

  const getOriginal = async (req: INotificationRequest) => {
    const ep = `api/${req.subtype}?_id=${req.idObject}`;
    const res = await getWithAuth(ep, {});
    return res.data[0];
  };

  const handleClick = async () => {
    const req = displayRequests.find((r) => r._id === requestID);
    if (req && req?.type === ERequestType.SHARE) {
      await handleShareAccept(req);
    }
    handleAction(ERequestStatus.ACCEPTED);
  };

  const handleSaveCustom = async (original: any, subtype: ERequestSubtype) => {
    let base = await handleCopy(original, subtype, false);
    const alreadyNamedComp = verifyCustomName(base, subtype);

    if (alreadyNamedComp) {
      openRenameModal(original.name, async (newName: string) => {
        base.name = newName;
        await handleSaveCustom(base, subtype);
      });
      return;
    }

    await saveComponent(base, subtype);
  };

  const saveComponent = async (base: any, subtype: ERequestSubtype) => {
    try {
      const ep = `api/${subtype}`;
      await postWithAuth(ep, base);
      await handleAddCustom(base, subtype);
      enqueueSnackbar(`Successfully added ${subtype} ${base.name}`, { variant: "success", autoHideDuration: 3000 });
    } catch (e) {
      PrintError([e]);
    }
  };

  return (
    <>
      <Button sx={{ paddingY: "5px" }} variant="contained" onClick={handleClick} title="Accept">
        {downloadIcon ? (
          <Download sx={{ fontSize: 18, color: ERequestStatusColor.COMPLETED }} />
        ) : (
          <Check sx={{ fontSize: 18, color: ERequestStatusColor.ACCEPTED }} />
        )}
      </Button>
      {RenameModal}
    </>
  );
};

export default AcceptButton;
